import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { Faq } from '@cp-mx/common';
import { fetchFaq } from './FaqSlice';
import { FaqContentSelector } from './FaqContentSelector';

export function useFaq(): AbstractContentState<Faq> {
    return useCmsContent(fetchFaq, FaqContentSelector);
}
